import { render } from "./DbsCouponButton.vue?vue&type=template&id=595ed51f"
import script from "./DbsCouponButton.vue?vue&type=script&lang=js"
export * from "./DbsCouponButton.vue?vue&type=script&lang=js"

import "./DbsCouponButton.vue?vue&type=style&index=0&id=595ed51f&lang=scss"
script.render = render

export default script